import React from 'react';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogContentText, 
  DialogActions, 
  Button,
  Box
} from '@mui/material';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';

const ConfirmDialog = ({ open, title, message, onConfirm, onCancel }) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      PaperProps={{
        sx: {
          borderRadius: '16px',
          padding: '10px',
          width: '100%',
          maxWidth: '400px'
        }
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', pt: 2 }}>
        <WarningAmberRoundedIcon sx={{ fontSize: 50, color: 'var(--danger)' }} />
      </Box>

      <DialogTitle sx={{ textAlign: 'center', fontWeight: 800, fontSize: '1.2rem', pt: 1 }}>
        {title || "Confirmation"}
      </DialogTitle>

      <DialogContent>
        <DialogContentText sx={{ textAlign: 'center', color: 'var(--text-main)', fontWeight: 500 }}>
          {message || "Êtes-vous sûr de vouloir continuer ? Cette action peut être irréversible."}
        </DialogContentText>
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'center', gap: 2, pb: 3, px: 3 }}>
        <Button 
          onClick={onCancel} 
          variant="outlined"
          sx={{ 
            borderRadius: '8px', 
            textTransform: 'none', 
            fontWeight: 700,
            color: 'var(--text-muted)',
            borderColor: '#d8dbe0',
            flex: 1
          }}
        >
          Annuler
        </Button>
        <Button 
          onClick={onConfirm} 
          variant="contained" 
          color="error"
          sx={{ 
            borderRadius: '8px', 
            textTransform: 'none', 
            fontWeight: 700,
            backgroundColor: 'var(--danger)',
            flex: 1,
            boxShadow: '0 4px 12px rgba(229, 83, 83, 0.2)'
          }}
        >
          Confirmer
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;